import { PanelBody, Button, RangeControl } from '@wordpress/components';
import { PanelColorSettings } from '@wordpress/block-editor';
import { __ } from '@wordpress/i18n';
import { getIconClass } from '../utils';

export default function IconControls( {
	attributes,
	setAttributes,
	setIsIconsModalOpen,
} ) {
	const { iconName, iconType } = attributes;
	const iconClass = getIconClass( iconName, iconType );

	return (
		<PanelBody
			title={ __( 'Icon', 'brandy-blocks' ) }
			initialOpen={ false }
		>
			<div
				style={ {
					display: 'flex',
					alignItems: 'center',
					gap: '12px',
					marginBottom: '16px',
				} }
			>
				{ iconName && (
					<i
						className={ iconClass }
						style={ { fontSize: '32px' } }
					/>
				) }
				<Button
					variant="secondary"
					onClick={ () => setIsIconsModalOpen( true ) }
				>
					{ iconName
						? __( 'Change icon', 'brandy-blocks' )
						: __( 'Choose icon', 'brandy-blocks' ) }
				</Button>
				{ iconName && (
					<Button
						variant="tertiary"
						isDestructive
						onClick={ () =>
							setAttributes( { iconName: '' } )
						}
					>
						{ __( 'Remove', 'brandy-blocks' ) }
					</Button>
				) }
			</div>
			<RangeControl
				__nextHasNoMarginBottom
				label={ __( 'Icon size', 'brandy-blocks' ) }
				value={ attributes.iconSize }
				onChange={ ( v ) => setAttributes( { iconSize: v } ) }
				min={ 16 }
				max={ 128 }
			/>
			<PanelColorSettings
				title={ __( 'Icon color', 'brandy-blocks' ) }
				initialOpen={ false }
				disableCustomColors={ false }
				colorSettings={ [
					{
						value: attributes.iconColor,
						onChange: ( v ) =>
							setAttributes( { iconColor: v } ),
						label: __( 'Color', 'brandy-blocks' ),
					},
				] }
			/>
		</PanelBody>
	);
}
